<style lang="sass" scoped>
	@import 'modal-new'
</style>

<template>
	<div class="modal-wrapper">
        <div class="title"></div>
        <div class="modal">
            <div class="wrapper">
                <div class="content">
                    <slot></slot>
                </div>
            </div>
        </div>
		<div class="btn-close" @click="close"></div>
	</div>
</template>

<script>
	export default {
		name: 'modal',
		data() {
			return {
                isShow: this.show
            }
		},
		props: {},
		watch: {},
		methods: {
			close() {
                this.$emit('modalClose');
            }
		},
		create() {
		},
		mounted() {

		},
		components: {}
	}
</script>
